import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  const firstBonusIndex = packageIncludes.findIndex(item => item.kind === 'bonus');
  const firstExtraIndex = packageIncludes.findIndex(item => item.kind === 'extra');
  return <section id="pricing" className="py-20 px-4 bg-neutral-100 relative" data-id="element-199" data-mp="1s8c1dtqc898z">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-200" data-mp="1x8gklrimri2w">
        <div className="text-center mb-10" data-id="element-201" data-mp="1x6vqg308a15k">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-3 text-neutral-900 uppercase" data-id="element-202" data-mp="2283067lxlaev">
            Your Complete <span className="text-amber-600" data-id="element-203" data-mp="2w0fwv5hgc05">Heavy Equipment Instructor Atlas</span> Package
          </h2>
          <p className="text-neutral-800/80 text-sm md:text-base" data-id="element-204" data-mp="7ubqx97iksjy">
            Everything You Need to Plan, Teach, Explain, Review & Assess Heavy Equipment Training More
            Effectively
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-neutral-200 border-2 border-amber-500 rounded-3xl p-1 relative shadow-xl shadow-neutral-900/10" data-id="element-205" data-mp="1hnvckutoofby">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-400 text-neutral-950 font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-206" data-mp="20g6823m0db01">
            <Sparkles size={14} data-id="element-207" data-mp="1rezoflo2bk2k" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-208" data-mp="k2pj1peeb9hb">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-6" loading="lazy" data-id="element-209" data-mp="g0m5mv861ute" />

            <p className="text-sm font-bold tracking-widest text-amber-700 mb-3" data-id="element-210" data-mp="hfx93mijhbkn">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-neutral-50 border border-neutral-200 rounded-xl p-4" data-id="element-211" data-mp="mei9pn1pdx9m">
              <li className="text-xs font-bold tracking-widest text-neutral-900" data-id="element-212" data-mp="ci5gsrdzfnfx">
                THE COMPLETE 6-IN-1 VISUAL TRAINING SYSTEM
              </li>
              {packageIncludes.map((item, itemIndex) => <React.Fragment key={item.label} data-id="element-213" data-mp="3j1wjk32x1zu" data-mpi={itemIndex}>
                  {itemIndex === firstBonusIndex && <li className="pt-2 text-xs font-bold tracking-widest text-neutral-900" data-id="element-214" data-mp="3kzjjo8kh5bjr">
                      PLUS 5 PROFESSIONAL INSTRUCTOR BONUSES
                    </li>}
                  {itemIndex === firstExtraIndex && <li className="pt-2 border-t border-neutral-200" aria-hidden="true" data-id="element-215" data-mp="3fzdur05la35d" />}
                  <li className={`flex items-start gap-2 text-sm ${item.kind === 'extra' ? 'font-bold uppercase tracking-wide text-neutral-900' : 'text-neutral-800'}`} data-id="element-216" data-mp="2xatkz4bfi292">
                    {item.kind === 'bonus' ? <Gift size={16} className="text-amber-500 shrink-0 mt-0.5" data-id="element-217" data-mp="31b576ljfwamn" /> : <Check size={16} className="text-amber-600 shrink-0 mt-0.5" data-id="element-218" data-mp="3g84mywog39s7" />}
                    <span data-id="element-219" data-mp="3b8rzqatnw0p3">{item.label}</span>
                  </li>
                </React.Fragment>)}
            </ul>

            <div className="mb-6" data-id="element-220" data-mp="3l0xrbjg04g3r">
              <p className="text-sm text-neutral-800/60 mb-1" data-id="element-221" data-mp="3l1z17kla6wjw">
                REGULAR VALUE: <span className="line-through" data-id="element-222" data-mp="2u9m7tkybsy3">$105 USD</span>
              </p>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-223" data-mp="3u1m46atnsaf2">
                <span className="text-2xl md:text-3xl text-neutral-800/70" data-id="element-224" data-mp="3tzj571aj36y7">TODAY:</span>
                <span className="text-4xl md:text-5xl font-extrabold tracking-tight text-amber-600" data-id="element-225" data-mp="hvzxcj8i4fxn">
                  $27 USD
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-226" data-mp="qr671taw7i5g">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-neutral-800/60" data-id="element-227" data-mp="30jze34svzvz">
              <span className="flex items-center gap-1.5" data-id="element-228" data-mp="806fqlfxdw90">
                <Lock size={12} className="text-amber-600" data-id="element-229" data-mp="81zllyipscfy" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-230" data-mp="d0awmckqwszr">
                <Zap size={12} className="text-amber-600" data-id="element-231" data-mp="1jfv3hf106zav" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-232" data-mp="1oddb923ab8ha">
                <Wallet size={12} className="text-amber-600" data-id="element-233" data-mp="1ofzjz51wvu13" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}